import React from "react";

export const useViewportWidth = () => {
    const [viewportWidth, setViewportWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => {
            setViewportWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return viewportWidth;
};
